import { JobEstimationDetail } from "../modals/JobEstimationDetail";
import { NotesSuggestion } from "../modals/NotesSuggestion";
import { AddNotesRequest } from "../modals/AddNotesRequest";
import { CommonMethodService } from "./CommonMethodService";

const apiIbsAdBaseUrl = "https://ibsapi.flowautobody.com/";
// const apiIbsAdBaseUrl = "http://127.0.0.1:3331/";

export class IBSAdonisService {
  private commonMethodService = new CommonMethodService();

  sendRequest(url: string, method: string, data?: any, token?: string) {
    let requestOptions: any = {
      method: method,
      headers: {
        "Content-Type": "application/json",
      },
    };
    const currentUserToken =
      this.commonMethodService.getDataFromStorage("currentUser");
    if (currentUserToken || token) {
      requestOptions["headers"] = {
        ...requestOptions["headers"],
        Authorization: `Bearer ${token ? token : currentUserToken.auth.token}`,
      };
    }
    if (data) {
      requestOptions["body"] = JSON.stringify(data);
    }
    return fetch(url, requestOptions);
  }

  public getJobEstimateDetailsById(
    id: string,
    token?: string
  ): Promise<JobEstimationDetail> {
    return new Promise((resolve, reject) => {
      this.sendRequest(
        apiIbsAdBaseUrl + "GetJobEstimateDetailsById/" + id,
        "GET",
        null,
        token
      )
        .then(async (res) => {
          if (res.ok) {
            const result: any = await res?.json();
            resolve(result);
          } else {
            reject(res);
          }
        })
        .catch((ex) => {
          console.log(ex);
          reject(ex);
        });
    });
  }

  public getJobEstimateDetailsByIds(ids: string[]) {
    return new Promise((resolve, reject) => {
      this.sendRequest(
        apiIbsAdBaseUrl + "GetJobEstimateDetailsByIds",
        "POST",
        ids
      )
        .then(async (res) => {
          if (res.ok) {
            const result = await res.json();
            resolve(result);
          } else {
            reject(res);
          }
        })
        .catch((ex) => {
          console.log(ex);
          reject(ex);
        });
    });
  }

  public getUserImageBase64(ids: string[]) {
    return new Promise((resolve, reject) => {
      this.sendRequest(
        apiIbsAdBaseUrl + "GetEstimationImagesByEstimationIds",
        "POST",
        ids
      ).then(async (res) => {
        if (res.ok) {
          const result = await res.json();
          resolve(result);
        } else {
          reject(res);
        }
      });
    });
  }

  getEstimatePDFUrl(estimateId: string) {
    return apiIbsAdBaseUrl + "GenerateEstimatePdf/" + estimateId + "/" + 0;
  }

  sendIssueJobRequest(issueJob: any, token?: string) {
    return new Promise((resolve, reject) => {
      this.sendRequest(apiIbsAdBaseUrl + "IssueJob", "POST", issueJob, token)
        .then(async (res) => {
          if (res.ok) {
            const result = await res.json();
            resolve(result);
          } else {
            reject(res);
          }
        })
        .catch((ex) => {
          console.log(ex);
          reject(ex);
        });
    });
  }

  addNotes(note: AddNotesRequest) {
    return new Promise((resolve, reject) => {
      this.sendRequest(apiIbsAdBaseUrl + "AddNotes", "POST", note)
        .then(async (res) => {
          if (res.ok) {
            const result = await res.json();
            resolve(result);
          } else {
            reject(res);
          }
        })
        .catch((ex) => {
          console.log(ex);
          reject(ex);
        });
    });
  }

  getEstimateNotesDetails(estimateId: string) {
    return new Promise((resolve, reject) => {
      this.sendRequest(
        apiIbsAdBaseUrl + "EstimateNotesDetails/" + estimateId,
        "GET"
      )
        .then(async (res) => {
          if (res.ok) {
            const result = await res.json();
            resolve(result);
          } else {
            reject(res);
          }
        })
        .catch((ex) => {
          console.log(ex);
          reject(ex);
        });
    });
  }

  getNoteSuggestion(): Promise<NotesSuggestion[]> {
    return new Promise((resolve, reject) => {
      this.sendRequest(apiIbsAdBaseUrl + "NoteSuggestion/", "GET")
        .then(async (res) => {
          if (res.ok) {
            const result = await res.json();
            resolve(result);
          } else {
            reject(res);
          }
        })
        .catch((ex) => {
          console.log(ex);
          reject(ex);
        });
    });
  }

  public updateWorkType(estimateId: string, workType: string) {
    return new Promise((resolve, reject) => {
      this.sendRequest(
        apiIbsAdBaseUrl + "UpdateWorkType/" + estimateId + "/" + workType,
        "PUT",
        null
      )
        .then(async (res) => {
          if (res.ok) {
            const result = await res.json();
            resolve(result);
          } else {
            reject(res);
          }
        })
        .catch((ex) => {
          console.log(ex);
          reject(ex);
        });
    });
  }
}
